import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'ls-card-atom',
  standalone: true,
  imports: [CardModule],
  templateUrl: './card-atom.component.html',
  styleUrl: './card-atom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardAtomComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
}
